import { useEffect, useRef } from 'react';
import useDialogStore from '../store/dialogStore';

export default function GlobalConfirmationModal() {
  const { isOpen, title, message, confirmText, cancelText, type, onConfirm, onCancel, close } = useDialogStore();
  const confirmBtnRef = useRef(null);

  // Handle ESC key and focus trapping
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        close();
        if (onCancel) onCancel();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    
    // Auto focus confirm button
    if (confirmBtnRef.current) {
      confirmBtnRef.current.focus();
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, close, onCancel]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        );
      case 'warning':
        return (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        );
      case 'success':
        return (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        );
      case 'info':
      default:
        return (
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        );
    }
  };

  return (
    <div className="gcm-overlay" onClick={() => { close(); if (onCancel) onCancel(); }}>
      <div className="gcm-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="gcm-title">
        <div className={`gcm-icon-wrap ${type}`}>
          {getIcon()}
        </div>
        <h2 id="gcm-title" className="gcm-title">{title}</h2>
        <p className="gcm-message">{message}</p>
        <div className="gcm-actions">
          {cancelText && (
            <button 
              type="button" 
              className="gcm-btn gcm-btn-cancel" 
              onClick={() => { close(); if (onCancel) onCancel(); }}
            >
              {cancelText}
            </button>
          )}
          <button 
            type="button" 
            ref={confirmBtnRef}
            className={`gcm-btn gcm-btn-confirm ${type}`} 
            onClick={() => { close(); if (onConfirm) onConfirm(); }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
